// Dependencies
import qs from 'query-string';
import nwApiSDK from '~/nw-api-sdk';

const { ServiceSDK } = nwApiSDK;

/**
 * Utility module for fetching data from the data URL
 */
export function fetch(
  url,
  requestParams = {},
  queryParams = {},
  method = 'POST',
  callback = () => {},
  callbackErr = () => {}
) {
  const params = {
    ...queryParams,
  };

  ServiceSDK.http({
    url: `${url}?${qs.stringify(params, { strict: false })}`,
    encoding: 'utf8',
    method,
    timeout: 30000,
    body: requestParams,
    json: true,
    callback: (err, res, body) => {
      if (err || (res && res.statusCode !== 200)) {
        // Invoke the callback
        callbackErr(err || res.body);
        return;
      }

      callback(body);
    },
  });
}

export default { fetch };
